import { ZipCode } from '@hc-frontend/core-types';
import { z } from 'zod';

export const SubmitZipPlateTrackingOptions = z.object({
  plateName: z.enum(['ZIP_CODE', 'ZIP_CODE_HEALTH']),
  zipCode: ZipCode.optional(),
});

export type SubmitZipPlateTrackingOptions = z.infer<
  typeof SubmitZipPlateTrackingOptions
>;
